import { Module } from "state/Module"
import * as Types from "state/gql/_types"

export const ReservationModule = new Module<Types.ReservationFragment, Types.GetReservationsQueryVariables, Types.Reservations_Insert_Input>({
    sortKey: 'start_date',
    sortOrder: 'asc'
})